import {
  GET_LABREQUESTQUOTE_FAIL,
  GET_LABREQUESTQUOTE_SUCCESS,
  GET_LABREQUESTQUOTES_FAIL,
  GET_LABREQUESTQUOTES_SUCCESS,
  ADD_LABREQUESTQUOTE_SUCCESS,
  ADD_LABREQUESTQUOTE_FAIL,
  UPDATE_LABREQUESTQUOTE_SUCCESS,
  UPDATE_LABREQUESTQUOTE_FAIL,
  DELETE_LABREQUESTQUOTE_SUCCESS,
  DELETE_LABREQUESTQUOTE_FAIL,  
  SET_STATE_LABREQUESTQUOTE
} from "./actionTypes";

const INIT_STATE = {
  labRequestQuotes: [],
  labRequestQuote: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestQuotes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTQUOTES_SUCCESS:
      return {
        ...state,
        labRequestQuotes: action.payload.labRequestQuotes,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTQUOTE:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTQUOTES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTQUOTE_SUCCESS:
      return {
        ...state,
        labRequestQuotes: [...state.labRequestQuotes, action.payload],
      };

    case ADD_LABREQUESTQUOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTQUOTE_SUCCESS:
      return {
        ...state,
        labRequestQuotes: state.labRequestQuotes.map(labRequestQuote =>
          labRequestQuote.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestQuote }
            : labRequestQuote
        ),
      };

    case UPDATE_LABREQUESTQUOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTQUOTE_SUCCESS:
      return {
        ...state,
        labRequestQuotes: state.labRequestQuotes.filter(
          labRequestQuote => labRequestQuote.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTQUOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTQUOTE_SUCCESS:
      return {
        ...state,
        labRequestQuote: action.payload,
      };

    case GET_LABREQUESTQUOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestQuotes;
